import dayjs from "dayjs";

import { Typography, Grid, Tooltip, IconButton } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

import { ToggleButtons } from "@aclymatepackages/atoms";

import { useAccountData } from "../../../helpers/firebase";

const DocumentationYear = ({ yearTag, editYearTag }) => {
  const [{ startDate }] = useAccountData();

  const currentYear = dayjs().year();
  const startYear = dayjs(startDate).year();

  return (
    <>
      <Typography variant="h6" gutterBottom color="textSecondary">
        Tag this document to a year
      </Typography>
      <Grid container spacing={1}>
        <Grid item>
          <ToggleButtons
            buttons={[...Array(currentYear - startYear + 1)].map((_, idx) => {
              const year = startYear + idx;
              return { value: year, name: year };
            })}
            value={yearTag}
            onChange={editYearTag}
          />
        </Grid>
        {yearTag && (
          <Grid item>
            <Tooltip title="Clear year tag">
              <IconButton onClick={() => editYearTag(null)}>
                <CancelIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
      </Grid>
    </>
  );
};
export default DocumentationYear;
